import { render, staticRenderFns } from "./dark.vue?vue&type=template&id=51fcea70"
import script from "./dark.vue?vue&type=script&lang=js"
export * from "./dark.vue?vue&type=script&lang=js"
import style0 from "./dark.vue?vue&type=style&index=0&id=51fcea70&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports